import ru from './ru.json'
import kz from './kz.json'
export const defaultLocale = 'ru'
export const languages = {
  ru: ru,
  kz: kz,
}